module.exports = __webpack_public_path__ + "static/media/BrainSorterLogo.55e28298.png";